import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { DepartureAirportFilterComponent, GroupedDepartureAirportFilterComponent } from '@/scopes/search/components/DepartureAirportFilterComponent'
import { useQuickSearchStore } from '@/scopes/search/components/QuickSearchBar/store'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useMultiSelectFilter, useSelectFilter } from '@/scopes/search/search/domain/hooks'
import { QuickSearchFilterProps } from '@/scopes/search/search/pages/SearchPage/components/QuickSearchFilters/types'
import { isEmpty } from 'ramda'
import * as React from 'react'

export function DepartureAirportQuickSearchItemFilter({ id, asSheet }: QuickSearchFilterProps) {
  const { isFetching, options, setSelection, selectedOptions } = useMultiSelectFilter('DepartureAirport')
  const { selectedValue: transportTypeValue } = useSelectFilter('TransportType')
  const { setActiveItem } = useQuickSearchStore()
  const { sendEvent } = useAnalytics()

  const handleConfirm = (selection: string[]) => {
    if (!isFetching) {
      setSelection(selection)

      if (selection.length) {
        sendEvent(
          createSearchFilterClickEvent({
            element: 'checkbox',
            type: 'airports',
            result: selection.join(','),
          }),
        )
      }
    }
    setActiveItem(null)
  }

  if (isEmpty(options) || transportTypeValue !== 'Flight') {
    return null
  }
  const showGroups = options.filter(o => o.groupInfo).length > 0

  const FilterComponent = showGroups ? GroupedDepartureAirportFilterComponent : DepartureAirportFilterComponent

  return (
    <FilterComponent
      id={id}
      asSheet={asSheet}
      onConfirm={handleConfirm}
      options={options}
      selectedOptions={selectedOptions}
      disabled={isFetching}
    />
  )
}
